import axiosInstance from '@/store/axios';
import { rejectError, rejectErrorApiV2 } from '@/store/helper';

export default {
  namespaced: true,
  state: {
    // file
    totalFileJobs: 0,
    processingFileJobs: 0,
    failedFileJobs: 0,
    // live
    totalLiveJobs: 0,
  },
  getters: {
    getTotalFileJobs(state) {
      return state.totalFileJobs;
    },
    getFailedJobs(state) {
      return state.failedFileJobs;
    },
    getProcessingJobs(state) {
      return state.processingFileJobs;
    },
    getTotalEncodings(state) {
      return Math.floor(((state.totalFileJobs - state.processingFileJobs) * 100) / state.totalFileJobs) || 0;
    },
    getTotalLiveJobs(state) {
      return state.totalLiveJobs;
    },
  },
  mutations: {
    setProcessingFileJobs(state, amount) {
      state.processingFileJobs = amount;
    },
    setFailedFileJobs(state, amount) {
      state.failedFileJobs = amount;
    },
    setTotalFileJobs(state, total) {
      state.totalFileJobs = total;
    },
    setTotalLiveJobs(state, total) {
      state.totalLiveJobs = total;
    },
  },
  actions: {
    getOverview({ commit }) {
      return axiosInstance.post('/api/2/overview-reports', {})
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          const fileJobsReport = result.data.report.file_jobs;
          const totalFileJobs = fileJobsReport.ready + fileJobsReport.processing + fileJobsReport.done;
          commit('setProcessingFileJobs', fileJobsReport.processing);
          commit('setFailedFileJobs', fileJobsReport.error);
          commit('setTotalFileJobs', totalFileJobs);
          const liveJobsReport = result.data.report.live_jobs;
          const totalLiveJobs = liveJobsReport.ready + liveJobsReport.processing;
          commit('setTotalLiveJobs', totalLiveJobs);
          return result;
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
